import { Tag } from 'nhsuk-react-components';
import useCampaign from '../../hooks/useCampaign.ts';
import { formatStatus, getStatusColour } from '../../utils/formattingUtils.ts';

interface IterationStatusProps {
  iterationId: string;
}

export default function IterationStatus({ iterationId }: IterationStatusProps) {
  const { getDynamoIterationDetails } = useCampaign();
  const iterationDetails = getDynamoIterationDetails(iterationId);

  const status = formatStatus(iterationDetails?.status ?? '');
  const color = getStatusColour(iterationDetails?.status);

  return <Tag color={color}>{status}</Tag>;
}
